module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Photo.77392bc0.svg";